// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Chwj","fileBtn":"File_fileBtn__Rv94Y","closeBtn":"File_closeBtn__3VM0-","fileSelected":"File_fileSelected__1dyVa","disabled":"File_disabled__zL-IN"};